import { KeyIndexImpl } from '../instructions';
/**
 * Generate a key index containing numeric keys from start to end
 * inclusive.
 */
var rangeindex = function (start, end) {
    var r = [];
    for (var i = start; i <= end; i++) {
        r.push(String(i));
    }
    return new KeyIndexImpl(r);
};
/**
 * @public
 */
export var BuddhistEraIndex = rangeindex(0, 0);
/**
 * @public
 */
export var GregorianEraIndex = rangeindex(0, 1);
/**
 * @public
 */
export var JapaneseEraIndex = rangeindex(0, 236);
/**
 * @public
 */
export var PersianEraIndex = BuddhistEraIndex;
/**
 * @public
 */
export var GregorianMonthsIndex = rangeindex(1, 12);
/**
 * @public
 */
export var DateTimePatternFieldValues = ['y', 'M', 'd', 'a', 'H', 'm', 's'];
/**
 * @public
 */
export var DayPeriodValues = [
    'noon',
    'midnight',
    'am',
    'pm',
    'morning1',
    'morning2',
    'afternoon1',
    'afternoon2',
    'evening1',
    'evening2',
    'night1',
    'night2',
];
/**
 * @public
 */
export var EraWidthValues = ['names', 'abbr', 'narrow'];
/**
 * @public
 */
export var FieldWidthValues = ['abbreviated', 'narrow', 'short', 'wide'];
/**
 * @public
 */
export var FormatWidthValues = ['short', 'medium', 'long', 'full'];
/**
 * @public
 */
export var QuarterValues = ['1', '2', '3', '4'];
/**
 * @public
 */
export var WeekdayValues = ['1', '2', '3', '4', '5', '6', '7'];
//# sourceMappingURL=calendar.js.map